import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
interface DeleteConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  loading: boolean;
}
export default function DeleteConfirmationModal({ open, onClose, onDelete, loading }: DeleteConfirmationModalProps) {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle>Delete Chat Session</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Are you sure you want to delete this chat session? This action cannot be undone.</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onDelete} variant="contained" color="error" disabled={loading} loading={loading}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
